module.exports = __webpack_public_path__ + "img/7.7b3f2c27.jpg";